import { NestedOption } from '../../shared/NestedDropdown'
import { CategoryNode, CategoryOption, SelectOption } from '../catalogueTypes'

const ANCESTRY_SEPARATOR = ' / '

const ancestryLabel = (option: CategoryOption): string => option.ancestry.map((ancestor) => ancestor.name).join(ANCESTRY_SEPARATOR)

const toNestedOption = (option: CategoryOption): NestedOption => {
  const ancestors = option.ancestry.slice(0, -1)
  return {
    label: ancestryLabel(option),
    name: option.name,
    ancestorsLabel: ancestors.length > 0 ? ancestors.map((ancestor) => ancestor.name).join(ANCESTRY_SEPARATOR) : undefined,
    value: option.id,
    depth: option.ancestry.length - 1
  }
}

export const allCategoryOptions = (options: CategoryOption[]): NestedOption[] => options.map(toNestedOption)

export const rootCategoryOptions = (options: CategoryOption[]): NestedOption[] =>
  options.filter((option) => option.parent_id === null).map(toNestedOption)

export const categoryOptionValue = (options: CategoryOption[], categoryId: number | null): SelectOption | null => {
  const option = options.find((candidate) => candidate.id === categoryId)
  return option ? { label: ancestryLabel(option), value: option.id } : null
}

export interface CategoryFormValues {
  name: string
  location: SelectOption | null
  attachment: File | null
  file_url: string | null
}

export const emptyCategoryValues = (): CategoryFormValues => ({
  name: '',
  location: null,
  attachment: null,
  file_url: null
})

export const categoryFormValues = (category: CategoryNode, categoryOptions: CategoryOption[]): CategoryFormValues => ({
  name: category.name,
  location: categoryOptionValue(categoryOptions, category.parent_id),
  attachment: null,
  file_url: category.file_url
})

export const toCategoryFormData = (values: CategoryFormValues): FormData => {
  const form = new FormData()
  form.append('name', values.name)
  if (values.attachment) form.append('attachment', values.attachment)
  form.append('parent_id', values.location ? String(values.location.value) : '')
  return form
}
